module.exports = __webpack_public_path__ + "static/logo-38a7686ca34f7de056457ba0f5f0c6fe.svg";